import React, { Component } from "react";
import "../assets/css/dash_styles.css";

class DashWrap extends Component {
  render() {
    return <div id="dash-page">{this.props.children}</div>;
  }
}
export default DashWrap;
